var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.icon)?_c('i',{staticClass:"menu-item-icon",class:_vm.icon}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('el-badge',{staticClass:"count-badge",attrs:{"value":_vm.count,"type":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }